import AIS_Background from "./assets/ais.png";
import AIS_Logo from "./assets/AIS_LOGO.jpg";

import BIS_Background from "./assets/BIS_Background.png";
import BIS_Logo from "./assets/BIS_Logo.ico";

import MTA_Background from "./assets/MTA_Logo.png";
import MTA_Logo from "./assets/MTA_Logo.ico";

import Default_Background from "./assets/default7.png";
import Default_Logo from "./assets/MTA_Logo.ico";

// Get the hostname (either localhost or IP address for local or external resource)
//const hostname_address = window.location.hostname;
//const companyOption = "Default";
const companyOption = "AIS";

const companyLogo =
  companyOption === "AIS"
    ? AIS_Logo
    : companyOption === "BIS"
      ? BIS_Logo
      : companyOption === "MTA"
        ? MTA_Logo
        : Default_Logo;

const backgroundImage =
  companyOption === "AIS"
    ? AIS_Background
    : companyOption === "BIS"
      ? BIS_Background
      : companyOption === "MTA"
        ? MTA_Background
        : Default_Background;

let companyWebsite = "";
let companyName = "";
let companyMoto = "";
if (companyOption === "AIS") {
  companyWebsite = "https://www.andinet.edu.et/";
  companyName = "Andinet International School";
  companyMoto =
    "Empowering minds, shaping futures, and creating global leaders  through excellence in education.";
} else if (companyOption === "BIS") {
  companyWebsite = "http://www.bisaddis.com/";
  companyName = "British International School, Ethiopia";
  companyMoto = "";
} else if (companyOption === "MTA") {
  companyWebsite = "http://www.bisaddis.com/";
  companyName = "Miraf Teachers' Academy";
  companyMoto = "";
} else if (companyOption === "Default") {
  companyWebsite = "http://www.yodbusiness.com/";
  companyName = "Miraf Teachers' Academy";
  companyMoto = "";
}

// Get the hostname (either localhost or IP address for local or external resource)
//const hostname_address = window.location.hostname;

//=========================CONFIGURATION  OPTIONS 1: LOCAL MACHINE==================
// const hostname_address = "localhost";
// const hostname_address = "localhost";
const hostname_address = "196.190.220.204";
// const api_port = 26;
// const hostname_address = "196.189.188.231";
// const hostname_address = "102.208.98.85";
//=========================CONFIGURATION  OPTIONS 2: LIVE MACHINE==================
// const hostname_address = "localhost";
const api_port = 5212;

//=========================CONFIGURATION  OPTIONS 3: TEST MACHINE==================

// const api_port = 5000;

const API_BASE_URL = `http://${hostname_address}:${api_port}`;

// const option = 0;
// const hostname_address =
//   option === 0
//     ? "localhost"
//     : option === 1 //          1   for live server machine (andinet)
//     ? "196.188.238.57"
//     : option === 2 //          2   for test server  (andinet)
//     ? "196.188.238.57"
//     : option === 3 //          3   for cloud server   (YOD Claud server)
//     ? "196.189.188.231"
//     : "localhost";

// const api_port =
//   option === 0
//     ? 5212
//     : option === 1
//     ? 5212
//     : option === 2
//     ? 5212
//     : option === 3
//     ? 5212
//     : 5212;
//=========================CONFIGURATION  OPTIONS 1: LOCAL MACHINE==================
// const hostname_address = "localhost";
//const api_port = 5212;

//=========================CONFIGURATION  OPTIONS 2: LIVE MACHINE==================
// const hostname_address = "196.189.188.231";
// const api_port = 5212;

//=========================CONFIGURATION  OPTIONS 3: TEST MACHINE==================
//const api_port = 7212;

// const API_BASE_URL = `http://${hostname_address}:${api_port}`;

export {
  API_BASE_URL,
  companyOption,
  companyWebsite,
  companyName,
  companyMoto,
  backgroundImage,
  companyLogo,
};
